import React from 'react'
import './footer.scss'
import { Container, Row, Col, Accordion } from 'react-bootstrap'
import { LogoWhite , ContactIcon , PeopleIcon } from '../../../icon/icons';
import { NavLink } from 'react-router-dom';
const Footer = () => {

    // Footer Data Object
    const footerData = [
        {
            title: "Who we serve",
            links: [
                { text: "Construction", href: "/whoweserve/constructioninsurance" },
                { text: "Dealerships", href: "/whoweserve/dealershipsinsurance" },
                { text: "Manufacturing and process industries", href: "/whoweserve/manufactureinsurance" },
                { text: "Retailers and distributors", href: "/whoweserve/distributorsandretailers" },
                { text: "Service Industries", href: "/whoweserve/serviceindustries" },
                { text: "Trucking", href: "/whoweserve/truckinginsurance" },
            ],
        },
        {
            title: "Company",
            links: [
                { text: "About us", href: "/aboutus" },
                { text: "Careers", href: "#/", external: true },
                { text: "Golf", href: "/golf" },
                { text: "The Sentry", href: "#/" },
            ],
        },
        {
            title: "Quick Links",
            links: [
                { text: "For Customers", href: "/customers" },
                { text: "Make a Payment", href: "/quickpay" },
                { text: "File a Claim", href: "/claims" },
                { text: "For Sentry Retirees", href: "#/" },
                { text: "For Medical Providers", href: "#/" },
            ],
        },
        {
            title: "Connect",
            links: [
                { text: "800-473-6879", href: "#/" },
                { text: "Contact us", href: "/contact-us" },
                { text: "Find an agent", href: "#/" },
            ],
        },
    ];


    return (
        <footer className="footer-wrapper">
            <Container>
                {/* Logo with Socials */}
                <div className="logo-Socials-icon">
                    <a href="/" className="logo-wrap">
                        <LogoWhite />
                    </a>
                    <div className="social-icon-wrapper">
                        <a href="https://www.facebook.com/SentryInsurance/" target="_blank" rel="noopener noreferrer">
                            <img src="https://images.ctfassets.net/xgr7yhvqn20n/6QIsk5VVBPfnNku5sLnAPY/ca16286575744105fd5e55a30baf6746/icon-social-facebook-addtl.svg" alt="Facebook" width="24" />
                        </a>
                        <a href="https://www.youtube.com/user/sentryinsurance" target="_blank" rel="noopener noreferrer">
                            <img src="https://images.ctfassets.net/xgr7yhvqn20n/4ezZ5Wqb7LJNzre30q7y19/00642d7a888d83741f6271cc23de03d5/icon-social-youtube-addtl.svg" alt="YouTube" width="24" />
                        </a>
                        <a href="https://twitter.com/SentryInsurance" target="_blank" rel="noopener noreferrer">
                            <img src="https://images.ctfassets.net/xgr7yhvqn20n/3viQ3ciBFvuHI0bxnWVuiC/b5fe58cbaa43bfe8bd0d7187115a053b/icon-social-x-addtl.svg" alt="Twitter" width="24" />
                        </a>
                        <a href="https://www.linkedin.com/company/sentry" target="_blank" rel="noopener noreferrer">
                            <img src="https://images.ctfassets.net/xgr7yhvqn20n/5nf4pXRDl8wru4Z5iGEkud/fac39d780880cc2a8ccee53f2fa9353d/icon-social-linkedin-addtl.svg" alt="LinkedIn" width="24" />
                        </a>
                        <a href="https://www.instagram.com/sentryinsurance_/" target="_blank" rel="noopener noreferrer">
                            <img src="https://images.ctfassets.net/xgr7yhvqn20n/28Eubq9nVPQYQTyVzlLtgz/b73f8fee4a4413186d84b4e94522569c/icon-social-instagram-addtl.svg" alt="Instagram" width="24" />
                        </a>
                    </div>
                </div>
                <Row className='hide-phone'>
                    {footerData.map((section, index) => (
                        <Col key={index} md={3} sm={6}>
                            <div className="common-footer-menu">
                                <h5>{section.title}</h5>
                                <ul className="quick-menu-list">
                                    {section.links.map((link, idx) => (
                                        <li key={idx}>
                                            <a
                                                href={link.href}
                                                className="text-white"
                                                target={link.external ? "_blank" : "_self"}
                                                rel={link.external ? "noopener noreferrer" : ""}
                                            >
                                                {link.text}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                    ))}
                </Row>

                {/* Accordion (Mobile View) */}
                <Accordion flush className="footer-accordation">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Who we serve</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled">
                                <li><NavLink to="/whoweserve/constructioninsurance">Construction</NavLink></li>
                                <li><NavLink to="/whoweserve/dealershipsinsurance">Dealerships</NavLink></li>
                                <li><NavLink to="/whoweserve/manufactureinsurance">Manufacturing and process industries</NavLink></li>
                                <li><NavLink to="/whoweserve/distributorsandretailers">Retailers and distributors</NavLink></li>
                                <li><NavLink to="/whoweserve/serviceindustries">Service industries</NavLink></li>
                                <li><NavLink to="/whoweserve/truckinginsurance">Trucking</NavLink></li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Company</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled">
                                <li><NavLink to="/aboutus">About us</NavLink></li>
                                <li><NavLink to="#/">Careers</NavLink></li>
                                <li><NavLink to="/golf">Golf</NavLink></li>
                                <li><NavLink to="#/">The Sentry</NavLink></li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Quick links</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled">
                                <li><NavLink to="/customers">For customers</NavLink></li>
                                <li><NavLink to="/quickpay">Make a payment</NavLink></li>
                                <li><NavLink to="/claims">File a claim</NavLink></li>
                                <li><NavLink to="#/">For Sentry retirees</NavLink></li>
                                <li><NavLink to="#/">For medical providers</NavLink></li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Connect</Accordion.Header>
                        <Accordion.Body>
                            <ul className="list-unstyled">
                                <li><NavLink to="#/">800-473-6879</NavLink></li>
                                <li><NavLink to="/contact-us">Contact us</NavLink></li>
                                <li><NavLink to="#/">Find an agent</NavLink></li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <hr className='global-hr' />

                <div className="lowerSection">
                    {/* Legal Links */}
                    <div className="legalLinks">
                        <a className="link whiteLink" href="/footer/customer-notifications">
                            <span>Customer notifications</span>
                        </a>
                        <a className="link whiteLink" href="/footer/legal-disclaimer">
                            <span>Legal disclaimer</span>
                        </a>
                        <a className="link whiteLink" href="/privacy">
                            <span>Privacy</span>
                        </a>
                        <a className="link whiteLink" href="/sitemap">
                            <span>Sitemap</span>
                        </a>
                        <a className="link whiteLink" href="/terms-and-conditions">
                            <span>Terms and conditions</span>
                        </a>
                        <a className="link whiteLink" href="/footer/web-accessibility">
                            <span>Web accessibility</span>
                        </a>
                        <a className="link whiteLink">
                            <span>Cookie Preferences</span>
                        </a>
                    </div>

                    {/* Copyright */}
                    <div className="copyright">
                        © <span className="CurrentYear">2024</span>&nbsp;
                        <span>Sentry Insurance, 1800 North Point Drive, Stevens Point, WI 54481</span>
                    </div>

                    {/* Legal Text */}
                    <div className="legalText">
                        <div className="Text">
                            <p>
                                If you are using a screen reader and having difficulty, please call 800-473-6879 for assistance.
                                <br />
                                <br />*Sentry has an AM Best Financial Strength Rating (FSR) of A+ (superior),
                                current as of June 2024. See{' '}
                                <a
                                    href="http://www.ambest.com/ratings/guide.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    ambest.com/ratings/guide.pdf
                                </a>{' '}
                                for rating information.
                                <br />
                                <br />
                                <a
                                    href="http://www.anthem.com/machine-readable-file/search"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Transparency in Coverage Rule: Anthem Machine-Readable File
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="FooterButtons">
                    <div className="iconLinkWrapper ">
                        <NavLink className="link">
                            <ContactIcon />
                            <p>800-473-6879</p>
                        </NavLink>
                    </div>
                    <div className="iconLinkWrapper ">
                        <NavLink className="link">
                            <PeopleIcon />
                            <p>Find an agent</p>
                        </NavLink>
                    </div>
                </div>
            </Container>
        </footer>
    )
}

export default Footer